module.exports = __webpack_public_path__ + "img/u28953.1bc318ff.png";